import { IUserContext } from '../server/types';

const USER_CONTEXT: IUserContext = window.__USER_CONTEXT__;

function isLoggedIn(): boolean {
  return !!USER_CONTEXT;
}

function isWixStaff(): boolean {
  return USER_CONTEXT && USER_CONTEXT.isWixStaff;
}

export { isLoggedIn, isWixStaff };
